import { useNavigate } from "react-router-dom";
import { Building2 } from "lucide-react";
import BannerArt from "@/components/customer/BannerArt";
import { useT } from "@/lib/i18n";

export default function FeaturedPromos({ cards }) {
  const nav = useNavigate();
  const t = useT();
  if (!cards?.length) return null;
  return (
    <section className="mx-auto max-w-7xl px-4 pt-16 sm:px-6" data-testid="featured-promos">
      <h2 className="font-heading text-2xl font-bold tracking-tight text-slate-900 sm:text-3xl">{t("Promo akomodasi")}</h2>
      <div className="mt-6 flex snap-x gap-5 overflow-x-auto pb-3">
        {cards.map((c, i) => (
          <button key={c.id} data-testid={`featured-card-${c.id}`} onClick={() => nav(c.type === "group" ? `/promo/${c.id}` : `/hotel/${c.property_id}`)}
            className="group relative aspect-[2.15/1] w-[88%] shrink-0 snap-start overflow-hidden rounded-2xl text-left shadow-sm transition-transform duration-200 hover:-translate-y-1 sm:w-[46%] lg:w-[31.5%]">
            <BannerArt c={c} i={i} />
            <span className="absolute left-0 top-0 z-20 rounded-br-xl bg-white/90 p-2 text-[#B4693E]"><Building2 className="h-5 w-5" /></span>
            {c.type === "group" && c.properties_count > 1 && <span className="absolute bottom-3 right-3 z-20 rounded-full bg-black/55 px-2.5 py-1 text-xs font-semibold text-white">{t("{n} properti", { n: c.properties_count })}</span>}
          </button>
        ))}
      </div>
    </section>
  );
}
